jQuery(document).ready(function ($) {

  // Header logic

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 0) {
        $('header').addClass('scrolled');
    } else {
        $('header').removeClass('scrolled');
    }
  });

  $('.burger').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('scroll-disable');
    $('.overlay').fadeIn();
    $('.header_menu_wr').addClass('visible');
    $('.header_menu .btn_main a').html('Start Free Trial');
  });

  $('.header .header_menu_wr_top .close').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('scroll-disable');
    $('.overlay').fadeOut();
    $('.header_menu_wr').removeClass('visible');
  });

  $('.role-guest .header .header_menu_container ul .menu-item a').on('click', function () {
      const menuItem = $(this).closest('.menu-item');
      if (menuItem.hasClass('header-menu-login')) {
          let go_to_app_popup = $('.open-app-modal-cookie');
          if (go_to_app_popup.length) {
              go_to_app_popup.fadeIn();
              go_to_app_popup.addClass('active');
          }
      }
      $('body').removeClass('scroll-disable');
      $('.overlay').fadeOut();
      $('.header_menu_wr').removeClass('visible');
  });

  $('.header-menu-login a').click(function (e) {
      e.preventDefault();
      $('.modal-login').modal({
          fadeDuration: 250
      });
  });

  // End Header logic

  // Login modal logic

  $('.modal-login').on('click', '.eye', function(){
    $(this).toggleClass('opened');
    var inputField = $(this).siblings('.form-row-input');
    if (inputField.attr('type') === 'text') {
      inputField.attr('type', 'password');
    } else {
      inputField.attr('type', 'text');
    }
  });

  $('.modal-login').on('click', '.btn-login', function(e){
    e.preventDefault();
    let login = $('.modal-login .login-user').val();
    let pwd = $('.modal-login .login-pwd').val();
    let rem = $('.modal-login #remember-pwd').is(':checked');
    let data = {
      action: 'landportal_ajax_login',
      login: login,
      pwd: pwd,
      rem: rem
    }
    $.ajax({
      type: "POST",
      url: script_settings.ajax_url,
      dataType: 'JSON',
      data: data,
      beforeSend: function (xhr) {
      },
      error: function (error) {
        console.log('error: ' + error);
      },
      success: function (response) {
        if (!response.success) {
          let error = response.data;
          let error_block = $('<div class="error-msg">' + error + '</div>');
          $('.login-error').addClass('show').html(error_block);
        } else {
          // Check if redirect URL is provided (for onboarding)
          if (response.data && response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            window.location.href = '/'; // Redirect to the homepage
          }
        }
      },
      complete: function (rsp) {
      }
    });
  });

  // End Login modal logic

  // Subscription logic

  $('.subscription__buy').on('click', function(e) {
    e.preventDefault();
    let data = {
      'action': 'landportal_ajax_buy_subscription',
      'product_id': $(this).data('productid'),
    }
    $.ajax({
      type: "POST",
      url: script_settings.ajax_url,
      dataType: 'JSON',
      data: data,
      beforeSend: function (xhr) {
      },
      error: function (error) {
        console.log('error: ' + error);
      },
      success: function (response) {
        if(response.data === 'added' || response.data === 'exists'){
          window.location.href = '/cart';
        }
      },
      complete: function (rsp) {
      }
    });
  });

  $(document).on('change', '.subscriptions-wr label.switch input', function(){
    let checked = $(this).prop('checked');
    $('.subscriptions-annual').toggleClass('hidden', !checked);
    $('.subscriptions-monthly').toggleClass('hidden', checked);
    $('span[data-period="m"]').toggleClass('active', !checked);
    $('span[data-period="a"]').toggleClass('active', checked);
  });

  // End Subscription logic

  // Homepage Analysis logic (guest) - will be moved to another file

  $('.analysis-content_content').on('click', '.analysis-item', function() {
    let imgLink = $(this).attr('data-image');

    $('.analysis-item').removeClass('active');
    $(this).addClass('active');

    let $imageContainer = $('.analysis-content_image img');

    $imageContainer.removeClass('active').on('transitionend', function() {
        $imageContainer.off('transitionend');
        $imageContainer.attr('src', imgLink);
        $imageContainer.addClass('active');
    });
  });

  $('.ai-report-wr-tabs').on('click', '.ai-report-wr-tabs-item', function() {
    let imgLink = $(this).attr('data-image');

    $('.ai-report-wr-tabs-item').removeClass('active');
    $(this).addClass('active');

    let $imageContainer = $('.ai-report-wr-tabs-img img');

    $imageContainer.removeClass('active').on('transitionend', function() {
      $imageContainer.off('transitionend');
      $imageContainer.attr('src', imgLink);
      $imageContainer.addClass('active');
    });
  });

  let reviewsWr = $('.reviews-wr_row');
  if(reviewsWr.length){
    reviewsWr.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  // End Homepage Analysis logic (guest)

  // FAQ logic 

  $('.faqs-wr').on('click', '.faq-wr__title', function(){
    var content = $(this).siblings('.faq-wr__text');
    if(content.is(':visible')){
      $(this).removeClass('faq-open');
      content.slideUp();
      return;
    }
    $('.faqs-wr .faq-wr__text').slideUp();
    $('.faq-wr').removeClass('faq-open').removeClass('faq-open-prev');
    $(this).closest('.faq-wr').prev().addClass('faq-open-prev');
    $(this).closest('.faq-wr').addClass('faq-open');
    content.slideDown();
  })

  // End FAQ logic


  // Search logic

  $('.search-wr .search-wr-dropdown .selected__option').click(function() {
    $('.search-options').toggleClass('active');
  });

  $('.search-wr .search-wr-dropdown .search__option').click(function(e) {
    e.preventDefault();
    let searchType = $(this).attr('aria-searchtype');
    $('.search__option.selected').removeClass('selected');
    $(this).addClass('selected');
    $('.search-wr-dropdown .selected__option').text($(this).text());
    $('.search-wr').attr('data-searchtype', searchType);
    if (searchType === 'parcelnumb' || searchType === 'owner' || searchType === 'propertyid') {
      $('.search-selects-wr').removeClass('hidden');
    } else {
      $('.search-selects-wr').addClass('hidden');
    }
    const countiesSelect = $('.search-wr .search-select[data-filter="county"]');
    const statesSelect = $('.search-wr .search-select[data-filter="state"]');
    function selectClear(){
      countiesSelect.empty().attr('disabled', 'disabled');
      statesSelect.val(null).trigger('change');
      $('#main_search_input').val('').css('padding-right', '12px');
      $('.remove-search-text').hide();
    }
    if($('ul.search-variants').length > 0){
      $('ul.search-variants').remove();
      $('.burger-wr').removeClass('active');
    }
    switch(searchType){
      case 'propertyid':
        $('#main_search_input, #main_search_input_disabled').attr('placeholder', 'Enter Property ID').show();
        $('.search-wr .search-btn, .coords-inputs-wr').removeClass('open');
        selectClear();
        if($(window).width() < 1660) {
          $('.map-wr').addClass('mini-desktop');
        }
        break;
      case 'parcelnumb':
        $('#main_search_input, #main_search_input_disabled').attr('placeholder', 'Enter Parcel Number').show();
        $('.search-wr .search-btn, .coords-inputs-wr').removeClass('open');
        selectClear();
        if($(window).width() < 1660) {
          $('.map-wr').addClass('mini-desktop');
        }
        break;
      case 'owner':
        $('#main_search_input, #main_search_input_disabled').attr('placeholder', 'Enter Owner Name').show();
        $('.search-wr .search-btn, .coords-inputs-wr').removeClass('open');
        selectClear();
        if($(window).width() < 1660) {
          $('.map-wr').addClass('mini-desktop');
        }
        break;
      case 'address':
        $('#main_search_input').attr('placeholder', 'Search by address, city, state or zip...').show();
        $('#main_search_input_disabled').attr('placeholder', 'Search by address, city, state or zip...').show();
        $('.search-wr .search-btn, .coords-inputs-wr').removeClass('open');
        $('.map-wr').removeClass('mini-desktop');
        selectClear();
        break;
      case 'coords':
        $('#main_search_input, #main_search_input_disabled').hide();
        $('.search-wr .search-btn, .coords-inputs-wr').addClass('open');
        selectClear();
        $('.map-wr').removeClass('mini-desktop');
        break;
      default:
        $('#main_search_input, #main_search_input_disabled').attr('placeholder', 'Address or zip or city or county or state').show();
        $('.search-wr .search-btn, .coords-inputs-wr').removeClass('open');
        selectClear();
        $('.map-wr').removeClass('mini-desktop');
    }
    $('.search-options').removeClass('active');
  });

  // End Search logic

  function isStreetViewActive() {
    var mapEl = document.getElementById('map');
    if (mapEl && mapEl.classList.contains('street-view-active')) {
      return true;
    }

    if (
      typeof MapUtils !== 'undefined' &&
      MapUtils.streetView &&
      typeof MapUtils.streetView.getVisible === 'function'
    ) {
      return MapUtils.streetView.getVisible() === true;
    }

    return false;
  }

  function closeMapAdditionalPanel() {
    if (!document.querySelector('[data-lp-map-controls]')) {
      $('.map-additional-wr__title').removeClass('active');
    }
    $('.map-additional-wr__options').removeClass('opened');

    if (window.LP_MAP_CONFIG || document.getElementById('lp-react-overlays-root')) {
      try {
        window.dispatchEvent(new CustomEvent('lp:close-overlays-panel'));
      } catch (e) {
        // no-op
      }
    }
  }

  $(document).on('click', '.map-additional-wr__title', function() {
    if (document.querySelector('[data-lp-map-controls]')) {
      return;
    }

    if (isStreetViewActive()) {
      closeMapAdditionalPanel();
      return;
    }

    // If the React overlays widget is mounted, prefer it and don't open legacy UI.
    if (window.LP_MAP_CONFIG || document.getElementById('lp-react-overlays-root')) {
      try {
        window.dispatchEvent(new CustomEvent('lp:toggle-overlays-panel'));
      } catch (e) {
        // no-op
      }
      return;
    }

    $(this).toggleClass('active');
    $('.map-additional-wr__options').toggleClass('opened');
  });
  $(document).on('click', '.map-additional-wr__close', function() {
    $('.map-additional-wr__title').removeClass('active');
    $('.map-additional-wr__options').removeClass('opened');
  });

  $('.contact-us-btn').on('click', function(e) {
    e.preventDefault();
    $('.modal-contact').modal({
      fadeDuration: 250
    });
  });

  $(document).on('click', '.anchor-link', function(e) {
    if(!$('body').hasClass('home')){
      window.location.href = '/';
    }
  });
});

// Close modal for open app popup

function closeAppModal(button) {
  const storage = button.getAttribute('data-storage') || '';

  fetch(script_settings.ajax_url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    body: 'action=manage_open_app_popup&storage=' + encodeURIComponent(storage)
  })
      .then(res => res.json())
      .then(data => {
        console.log('Server response:', data);
      });

  const popup = button.closest('.open-app-modal-cookie, .modal-open-app-if-mobile-session');
  if (popup) {
    popup.style.display = 'none';
  }
}

// End Close modal for open app popup
